import React from 'react';
import { useAuth } from '../../../../context/security/AuthProvider'
import { useActionsInventoryArticles, useDispatchInventoryArticles, useInventoryArticles } from '../../../../context/inventory/InventoryArticlesByWarehouseProvider'
import { formatNumberCOP } from '../../../../utilities/app.utilities'
import { LOADED } from '../../../../api/constant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { ExportAsExcel } from "react-export-table";
import Pagination from '../../../app/atoms/Pagination';
import { types } from '../../../../reducers/inventory/inventoryArticlesReducer';


export const InventoryDetailByWarehouseTab = () => {

  const stateAuth = useAuth();

  const state = useInventoryArticles();

  const dispatch = useDispatchInventoryArticles();

  const actions = useActionsInventoryArticles();

  const { detail_articles, selected_warehouses } = state;
  const warehouseLabel =
    selected_warehouses.length === 0
      ? "Sin_almacen"
      : selected_warehouses.length === 1
        ? selected_warehouses[0].name
        : "Varios_almacenes";

  const filteredDataToExcel = detail_articles.elements.map((item) => ({
    code: item.code,
    name: item.name,
    warehouse: item.warehouse_name ? `${item.warehouse_code || ""} - ${item.warehouse_name}` : "—",
    measure_name: item.measure_name,
    stock: formatNumberCOP(item.stock),
    equivalent_name: item.equivalent_name,
    stock_in_equivalent_measure_main: formatNumberCOP(item.stock_in_equivalent_measure_main),
    lote: item.lote,
    date_expired: item.date_expired,
  }));

  return (
    <div className='row'>

        <div className="col-md-10">

          <div style={{ marginTop: "23px" }}>
            <table className="table table-default-app" >
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Código</th>
                  <th scope="col">Articulo</th>
                  <th scope="col">Almacén</th>
                  <th scope="col">Und. medida</th>
                  <th scope="col">Cantidad</th>
                  <th scope="col">Und. medida principal</th>
                  <th scope="col">Cant. Unidad Principal</th>
                  <th scope="col">Lote</th>
                  <th scope="col">Fecha de vencimiento</th>
                </tr>
              </thead>

              <tbody>
                {detail_articles.elements.map((item, i) => {
                  const dateExpired = item.date_expired === "2300-12-31" ? "N.A" : (item.date_expired ?? "N.A");
                  const lote = item.date_expired === "2300-12-31" ? "N.A" : (item.lote ? item.lote : "N.A");
                  return (
                    <tr
                      className={"cursor-pointer td-hoverme"}
                      key={item.id ?? `detail-${item.item_id}-${item.warehouse_id}-${i}`}
                    >
                      <td>{item.code}</td>
                      <td>{item.name}</td>
                      <td>{item.warehouse_code ? `${item.warehouse_code} - ${item.warehouse_name}` : item.warehouse_name ?? "—"}</td>
                      <td>{item.measure_name}</td>
                      <td className="txt-right">{formatNumberCOP(item.stock)}</td>
                      <td>{item.equivalent_name}</td>
                      <td className="txt-right">{formatNumberCOP(item.stock_in_equivalent_measure_main)}</td>
                      <td>{lote}</td>
                      <td>{dateExpired}</td>
                    </tr>
                  );
                })

                }
              </tbody>
            </table>
          </div>
          <div className="flex justify-end">
          <Pagination
            onChangepage={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_DETAIL_ARTICLES,
                payload: { name: "page", value: e },
              })
            }
            page={detail_articles.filter.page}
            limit={detail_articles.filter.limit}
            rows={detail_articles.rows}
          />
          </div>
        </div>

        <div className="col-md-auto">
        <ExportAsExcel
            data={filteredDataToExcel}
            headers={["Código", "Articulo", "Almacén", "Und. medida", "Cantidad", "Und. medida principal", "Cant. Unidad Principal", "Lote", "Fecha de vencimiento"]}
            fileName={`StockDeArticulos_${warehouseLabel}_${Date.now()}`}
            name='StockDeArticulos'
        >

          {(props)=> (
            
            <div
            className="flex btn-default"
            {...props}
            >
            <FontAwesomeIcon
              className="margin-auto"
              icon={faFileExcel}
            />
            &nbsp;
            <span> Exportar </span>
            </div>
          )}
        </ExportAsExcel>
        
          
        </div>


    </div>
  )
}

